/* eslint-disable */
import { apiFetch } from "../auth/apiClient";

const BASE = "/api/goods";

export const goodsApi = {
  list: (params = {}) => {
    const q = new URLSearchParams();
    if (params.q) q.set("q", params.q);
    if (params.category) q.set("category", params.category);
    if (params.mine) q.set("mine", "true");
    if (params.skip != null) q.set("skip", String(params.skip));
    if (params.limit != null) q.set("limit", String(params.limit));
    return apiFetch(`${BASE}?${q}`);
  },
  me: () => apiFetch(`${BASE}/me`),
  get: (id) => apiFetch(`${BASE}/${id}`),
  create: (body) => apiFetch(BASE, { method: "POST", body }),
  patch: (id, body) => apiFetch(`${BASE}/${id}`, { method: "PATCH", body }),
  markSold: (id) => apiFetch(`${BASE}/${id}/sold`, { method: "POST" }),
  delete: (id) => apiFetch(`${BASE}/${id}`, { method: "DELETE" }),
  photoUrl: (listingId, photoId) => `/api/goods/${listingId}/photos/${photoId}`,
};
